import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';

@Component({
    selector: 'ca-conversation-list-export-failed-notification',
    templateUrl: './conversation-list-export-failed-notification.component.html',
    styleUrls: ['./conversation-list-export-failed-notification.component.scss'],
    standalone: false
})
@NotificationType(
  'ConversationListExportFailedNotification',
  ConversationListExportFailedNotificationComponent
)
export class ConversationListExportFailedNotificationComponent implements OnInit {
  data: NotificationDto;

  constructor() {}

  ngOnInit(): void {}

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector
  ) {
    var toastrId = toastr.error('Conversation::ConversationListReportFailedMessage');

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap
      .pipe(take(1))
      .subscribe(() => this.toasterClickedHandler(notificationService, notificationId));
  }

  static toasterClickedHandler(notificationService: NotificationService, notificationId: string) {
    notificationService.markAsRead(notificationId).subscribe();
  }
}
